import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError, timeout } from 'rxjs/operators';
import { ReadConfigService } from '../common/read-config.service';
import { Global } from '../../global.constants';
import { share } from 'rxjs/operators';

@Injectable()
export class MessagesService {

  public collection$: Observable<any>;
  private collectionObserver: any;
  private collection: any;

  constructor(private http: HttpClient,
    private readConfigService: ReadConfigService) {
    this.collection = new Array<string>();
    this.collection$ = new Observable((observer: any) => {
      this.collectionObserver = observer;
    }).pipe(share());
  }

  readonly rootUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });

  getMessageTopics(): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_MESSAGETOPICS_ENDPOINT;
    return this.http.get<any>(url, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getSecureMessages(inputData: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_SECUREMESSAGES_ENDPOINT;
    return this.http.post<any>(url, inputData, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  sendMessage(inputData: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_SEND_MESSAGE_ENDPOINT;
    return this.http.post<any>(url, inputData, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  readMessage(msgId: any): Observable<any> {
    const params = new HttpParams()
      .set('msgId', msgId);
    const url = this.rootUrl + Global.BASE_READ_MESSAGE_ENDPOINT;
    return this.http.get<any>(url, { headers: this.reqHeader, params })
      .pipe(this.handleError());
  }

  deleteMessage(inputData: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_DELETE_MESSAGE_ENDPOINT;
    return this.http.post<any>(url, inputData, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getUnreadMessageCount(inputData: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_UNREADMESSAGE_COUNT_ENDPOINT;
    return this.http.post<any>(url, inputData, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  setMsgCount(value: string) {
    sessionStorage.setItem('unreadMsgCount', value);
    this.collectionObserver.next(value);
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }
}
